import { Action, ActionRef } from 'pbts/c1/api/action/v1/action'
import { ActionServiceClient } from 'pbts/c1/api/action/v1/action.client'
import { createMutationApi } from './lib/createMutationApi'
import { createPagedListApi } from './lib/createPagedListApi'
import { createUnaryApi } from './lib/createUnaryApi'

export const createActionApi = createMutationApi(
    ActionServiceClient,
    'create',
    (response) => response.action as Action,
    ActionRef.typeName,
)

export const updateActionApi = createMutationApi(
    ActionServiceClient,
    'update',
    (response) => response.action as Action,
    ActionRef.typeName,
)

export const getActionApi = createUnaryApi(
    ActionServiceClient,
    'get',
    (response) => response.action as Action,
    ActionRef.typeName,
)

export const deleteActionApi = createMutationApi(
    ActionServiceClient,
    'delete',
    undefined,
    ActionRef.typeName,
)

export const listActionsApi = createUnaryApi(
    ActionServiceClient,
    'list',
    (response) => response.actions as Action[],
    ActionRef.typeName,
)

export const searchActionsApi = createPagedListApi(
    ActionServiceClient,
    'search',
    undefined,
    ActionRef.typeName,
)
